import FilterTreeHorizontalPlaceholder from './Horizontal';
import FilterTreeVerticalPlaceholder from './Vertical';

export type FilterTreePlaceHolderProps = {
  layout?: 'horizontal' | 'vertical';
};

export const FilterTreePlaceHolder = ({ layout }: FilterTreePlaceHolderProps) => {
  switch (layout) {
    case 'horizontal':
      return <FilterTreeHorizontalPlaceholder />;

    default:
      return <FilterTreeVerticalPlaceholder />;
  }
};
